
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResistor2 as ObiResistor2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-resistor-2.js';
 
 
 

 
 export const ObiResistor2 = createComponent({
   react: React,
   tagName: 'obi-resistor-2',
   elementClass: ObiResistor2Element,
   events: {
     
   }
  });
 
 